
import { required } from 'vuelidate/lib/validators'

export default function () {
  if (this.dwellerGuestListOptions.length >= 1) {
    return {
      schedule: {
        event_name: {
          required
        },
        tower_id: {
          required
        },
        unit_id: {
          required
        }
      }
    }
  } else {
    return {
      schedule: {
        event_name: {
          required
        },
        tower_id: {
          required
        },
        unit_id: {
          required
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/resources/validations.js